import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: 'Czy wszystko jest naprawdę w PDF?',
  answer: 'Tak. Wszystkie 6 tomów i 6 bonusów to pliki PDF gotowe do pobrania natychmiast po zakupie. Możesz je drukować lub przeglądać na tablecie, laptopie lub telefonie.'
}, {
  question: 'Czy to pasuje do mojego stylu nauczania?',
  answer: 'System jest elastyczny i modułowy. Możesz używać dokładnie tych części które potrzebujesz. Nie musisz zmieniać swojego podejścia — uzupełniasz je gotowymi narzędziami.'
}, {
  question: 'Czy potrzebuję specjalnej wiedzy żeby to używać?',
  answer: 'Nie. System jest zaprojektowany tak żeby każdy nauczyciel WF lub trener siatkówki mógł zacząć od pierwszego dnia bez żadnego szkolenia.'
}, {
  question: 'Kiedy otrzymam dokumenty?',
  answer: 'Natychmiast po potwierdzeniu płatności. Link do pobrania zostanie wysłany na Twój adres email w ciągu kilku minut.'
}, {
  question: 'Co się stanie jeśli nie będę zadowolony?',
  answer: 'Zwracamy 100% kwoty w ciągu 7 dni bez pytań i bez skomplikowanych procedur.'
}, {
  question: 'Dlaczego cena jest tak niska?',
  answer: 'Stworzyliśmy ten system żeby był dostępny dla każdego nauczyciela i trenera w Polsce. Zależy nam na dotarciu do jak największej liczby specjalistów — nie na maksymalizacji ceny.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-cream-bg py-12 md:py-20 px-4 md:px-6" data-id="element-97">
      <div className="max-w-4xl mx-auto" data-id="element-98">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-display font-bold text-center text-white mb-8 md:mb-12" data-id="element-99">
          Najczęściej zadawane pytania
        </h2>

        <div className="space-y-3 md:space-y-4" data-id="element-100">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className="bg-[#1A3257] rounded-2xl shadow-sm border border-[#1E3A5F] overflow-hidden" data-id="element-101">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex items-center justify-between p-5 md:p-6 text-left hover:bg-[#1E3A5F]/50 transition-colors" aria-expanded={isOpen} data-id="element-102">
                  <span className="font-bold text-white text-base md:text-lg pr-4" data-id="element-103">
                    {faq.question}
                  </span>
                  <ChevronDown className="w-5 h-5 md:w-6 md:h-6 text-gold-accent flex-shrink-0 transition-transform duration-300" style={{
                transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)'
              }} data-id="element-104" />
                </button>

                <div className="overflow-hidden transition-all duration-300" style={{
              maxHeight: isOpen ? '500px' : '0px',
              opacity: isOpen ? 1 : 0
            }} data-id="element-105">
                  <div className="px-5 md:px-6 pb-5 md:pb-6 text-sm md:text-base text-[#E8EAF0] leading-relaxed" data-id="element-106">
                    {faq.answer}
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}